const optionsURL = s => `/api/options/${s}`;

export const optionsAPI = {
  getOrganizationSubtypes() {
    return ['Individual or sole proprietor', 'Non-profit', 'Corporation or LLC', 'Other'];
  },
  async byGroups(groups = []) {
    const groupedOptions = {};

    groups.forEach(g => { groupedOptions[g] = []; });

    const response = await axios.post(optionsURL('by-groups'), { groups }).catch(r => r.response);

    try {
      return (response.data.options || []).reduce((acc, option) => {
        if (!acc[option.group]) {
          acc[option.group] = [];
        }

        acc[option.group].push(option);

        return acc;
      }, groupedOptions);
    } catch (_) {
      return groupedOptions;
    }
  }
}